import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { MembersPage } from '@/features/admin';
import { MembersSearchSchema } from '@/features/admin/search';

export const Route = createFileRoute('/_auth/o/$orgId/admin/members')({
  validateSearch: (search) => MembersSearchSchema.parse(search),
  component: MembersRoute,
});

function MembersRoute() {
  const { orgId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <MembersPage
      orgId={orgId}
      tab={tab ?? 'members'}
      onTabChange={(next) => {
        void navigate({ search: { tab: next === 'members' ? undefined : next }, replace: true });
      }}
    />
  );
}
